/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface CentreSearch
 */
export interface CentreSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof CentreSearch
     */
    code?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof CentreSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof CentreSearch
     */
    directeur?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof CentreSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<number>}
     * @memberof CentreSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CentreSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CentreSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof CentreSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof CentreSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CentreSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof CentreSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof CentreSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the CentreSearch interface.
 */
export function instanceOfCentreSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CentreSearchFromJSON(json: any): CentreSearch {
    return CentreSearchFromJSONTyped(json, false);
}

export function CentreSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): CentreSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : TextSearchFromJSON(json['code']),
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'directeur': !exists(json, 'directeur') ? undefined : TextSearchFromJSON(json['directeur']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function CentreSearchToJSON(value?: CentreSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': TextSearchToJSON(value.code),
        'nom': TextSearchToJSON(value.nom),
        'directeur': TextSearchToJSON(value.directeur),
        'actif': BooleanSearchToJSON(value.actif),
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

